import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PatientsService } from '../patients.service';

@Component({
    selector: 'app-pat-documents',
    templateUrl: './pat-documents.component.html',
    styleUrls: ['./pat-documents.component.scss'],
    standalone: false
})
export class PatDocumentsComponent implements OnInit {
  @Output() closed = new EventEmitter<void>();
  @Input() showDocuments: boolean = false;

  selectedFile: File | null = null;
  documentTitle: string = '';
  documentComments: string = '';
  errorUploadDocs: string = '';
  documents: any[] = [];
  showDeleteAlert: boolean = false;
  toDeleteDocument: any = null;

  constructor(private http: HttpClient, public PatientsService: PatientsService) {}

  ngOnInit(): void {
    if (this.showDocuments) {
      this.getDocuments();
    }
  }

  close() {
    this.closed.emit();
  }

  onFileSelected(event: any) {
    this.errorUploadDocs = '';
    const file = event.target.files[0];
    if (!file) return;
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif', 'image/jpg'];
    if (!allowedTypes.includes(file.type)) {
      this.errorUploadDocs = 'Unauthorized file type';
      this.selectedFile = null;
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      this.errorUploadDocs = 'File size exceeds 5 MB';
      this.selectedFile = null;
      return;
    }
    this.selectedFile = file;
  }

  saveDocument() {
    this.errorUploadDocs = '';
    if (!this.selectedFile) return;
    const formData = new FormData();
    formData.append('file', this.selectedFile);
    formData.append('title', this.documentTitle);
    formData.append('comments', this.documentComments);
    formData.append('patId', String(this.PatientsService.currentPatient.PID));
    this.http.post('/api/patient/uploadDocs', formData).subscribe(
      () => {
        if (this.showDocuments) {
          this.getDocuments();
          this.selectedFile = null;
          this.documentComments = '';
          this.documentTitle = '';
        } else {
          this.close();
        }
      },
      error => { this.errorUploadDocs = error?.error?.message || 'Upload failed'; }
    );
  }

  getDocuments() {
    this.http.get(`api/patient/getDocuments/${this.PatientsService.getPat().PID}`).subscribe((data: any) => {
      this.documents = data.documents.map((doc: any) => ({
        ...doc,
        fileType: doc.type.split('/')[1]
      }));
    });
  }

  openDocument(docId: number) {
    window.open(`api/patient/getDocument/${docId}`);
  }

  deleteDocument() {
    if (!this.toDeleteDocument?.AutoIndex) return;
    this.http.delete(`api/patient/document/${this.toDeleteDocument.AutoIndex}`).subscribe(() => {
      this.getDocuments();
      this.toDeleteDocument = null;
      this.showDeleteAlert = false;
    });
  }

  formatSize(bytes: number): string {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }
}
